import React, { useState } from 'react';
import PropTypes from 'prop-types';
import emailjs from '@emailjs/browser';
import { Oval } from 'react-loader-spinner';

const DeleteAccount = ({ data }) => {
  const [emailInput, setEmailInput] = useState('');
  const [isErrorValidation, setErrorValidation] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isSuccessValidation, setSuccessValidation] = useState(false);

  const { description, errorMessage, submit, successMessage, title } = data;

  const handleTextChange = (event) => {
    setEmailInput(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorValidation(false);
    setSuccessValidation(false);

    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isEmail = re.test(emailInput);

    if (isEmail) {
      setLoading(true);
      emailjs
        .sendForm('service_2xmmmmt', 'template_butap3d', event.target, 'GHgO3tZ5pLb5SPjnL')
        .then(() => {
          setErrorValidation(!isEmail);
          setSuccessValidation(isEmail);
        })
        .catch(() => {
          setErrorValidation(true);
          setSuccessValidation(false);
        })
        .finally(() => setLoading(false));
    } else {
      setErrorValidation(true);
      setSuccessValidation(false);
    }
  };

  return (
    <div className="delete-account">
      <h1>{title}</h1>
      <p style={{ maxWidth: '700px' }}>{description}</p>
      <form onSubmit={handleSubmit}>
        <h6>E-mail:</h6>
        <input type="email" name="email" value={emailInput} onChange={handleTextChange} />
        {isErrorValidation && <p style={{ color: 'red' }}>{errorMessage}</p>}
        <input type="submit" value={submit} />
        {isLoading && (
          <Oval
            height={50}
            width={50}
            color="#4fa94d"
            visible={isLoading}
            ariaLabel="oval-loading"
            secondaryColor="#4fa94d"
            strokeWidth={2}
            strokeWidthSecondary={2}
            wrapperStyle={{ display: 'unset' }}
          />
        )}
        {isSuccessValidation && <p style={{ color: 'green' }}>{successMessage}</p>}
      </form>
    </div>
  );
};

DeleteAccount.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    successMessage: PropTypes.string.isRequired,
    submit: PropTypes.string.isRequired,
  }).isRequired,
};

export default DeleteAccount;
